import React from 'react'
import { PolarViewBox } from 'recharts/types/util/types'
import { NO_BREAK_SPACE } from 'src/Libs/chart-kit'
import { UnitTypes } from 'src/Libs/types'

interface ShopPieChartCustomLabelProps {
  viewBox: PolarViewBox
  filledColor: string
  percentage: string | number
}

/*
 * Component that renders a custom label in the middle of the chart showing percentage.
 */
const ShopPieChartCustomLabel: React.FC<ShopPieChartCustomLabelProps> = ({ viewBox, filledColor, percentage }) => {
  const { cx, cy } = viewBox
  return (
    <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle" fill={filledColor}>
      {percentage + NO_BREAK_SPACE + UnitTypes.percentage}
    </text>
  )
}

export default ShopPieChartCustomLabel
